import { Badge } from '@wyz/ui';
import * as React from 'react';
import { Trans } from '~/common/context';
import {
  CONTAINER_ORDER_STATUS_COLOR_LOOKUP,
  CONTAINER_ORDER_STATUS_LABEL_LOOKUP,
} from '~/common/translators';
import type { IContainerOrder } from '~/common/types';

type ContainerOrderStatus = IContainerOrder['status'];
type BadgeProps = React.ComponentProps<typeof Badge>;
const StatusBadge: React.FC<{
  status: ContainerOrderStatus;
  size?: BadgeProps['size'];
}> = ({ status, size }) => {
  const statusColor = CONTAINER_ORDER_STATUS_COLOR_LOOKUP[status];
  const statusKey = CONTAINER_ORDER_STATUS_LABEL_LOOKUP[status];

  return (
    <Badge bg={statusColor ?? 'secondary'} size={size ?? 'xs'} pill>
      {statusKey ? <Trans i18nKey={statusKey} /> : status}
    </Badge>
  );
};

export default StatusBadge;
